import { NotFoundRouteProps } from "@tanstack/react-router"
import { ElementType } from "react"
import { useTranslation } from "react-i18next"

import { NOT_FOUND_SESSION } from "@/utilities/globals"
import { useTheme } from "@/utilities/hooks/useTheme"

import { LinkButton } from "../atoms/Button"
import Card from "../atoms/Card"
import Heading from "../atoms/Heading"
import Text from "../atoms/Text"

import Footer from "./navigation/Footer"
import TopNavigationBar from "./navigation/TopNavigationBar"

function RootNotFound(props: NotFoundRouteProps) {
  const { documentThemeMode, qrLookupID } = useTheme()
  const whiteLabel =
    documentThemeMode === "whiteLabel" && qrLookupID
      ? { qrLookupID }
      : undefined
  const { t } = useTranslation(["common", "errors"])

  const isSessionNotFound = (props.data as any)?.type === NOT_FOUND_SESSION
  const ElementTag = (isSessionNotFound ? "main" : "div") as ElementType

  return (
    <>
      {isSessionNotFound && <TopNavigationBar />}
      <ElementTag className="error-boundary">
        <Card>
          <Heading className="center">
            {isSessionNotFound
              ? t("notFound.isSessionNotFound.header", { ns: "errors" })
              : "404"}
          </Heading>
          {isSessionNotFound ? (
            <Text className="center">
              {t("notFound.isSessionNotFound.body", { ns: "errors" })}
            </Text>
          ) : (
            <Text className="center">
              {t("common.notFound", { ns: "errors" })}
            </Text>
          )}

          <LinkButton
            buttonType="primary"
            to={whiteLabel ? "/qr/$qrLookupID/welcome" : "/"}
            params={whiteLabel}
            preload={false}
          >
            {t("common.goHome", { ns: "common" })}
          </LinkButton>
          <Text className="center">
            {t("common.getHelp", { ns: "common" })}{" "}
            <LinkButton
              buttonType="primary"
              presentation="link"
              to={whiteLabel ? "/qr/$qrLookupID/help" : "/help"}
              style={{ textDecoration: "underline" }}
              params={whiteLabel}
            >
              {t("common.clickHere", { ns: "common" })}
            </LinkButton>
          </Text>
        </Card>
      </ElementTag>
      {isSessionNotFound && <Footer />}
    </>
  )
}

export default RootNotFound
